// extracted by mini-css-extract-plugin
export default {"keyboard":"VirtualKeyboard_keyboard__jY2kn","handle":"VirtualKeyboard_handle__zKFce","handleLabel":"VirtualKeyboard_handleLabel__-0LXK","closeBtn":"VirtualKeyboard_closeBtn__psO3R"};